var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":"详情","destroy-on-close":true,"footer":null},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }